import {
  Home,
  Building2,
  Building,
  Plus,
  Upload,
  Download,
  Bell,
  MessageSquare,
  Users,
  Pill,
  Circle,
  type LucideIcon,
} from "lucide-react";

// Ícone por label de topo, separado de config/menu.ts para a árvore do menu
// continuar sendo só dados.
const ICONS_BY_LABEL: Record<string, LucideIcon> = {
  Início: Home,
  Instituições: Building2,
  "Silpi Farma": Pill,
  Franquias: Building,
  Cadastros: Plus,
  Importação: Upload,
  Exportação: Download,
  Notificações: Bell,
  Mensageria: MessageSquare,
  Usuários: Users,
};

export function iconForLabel(label: string): LucideIcon {
  return ICONS_BY_LABEL[label] ?? Circle;
}
